<template>
  <div class="content-webview">
    <div v-if="type === Dict.linkType.video" class="medie-video __flex __flex-vc __flex-cc">
      <img @click="goBack()" src="@/assets/images/icon/close.png" alt="" class="close-img">
      <video width="100%" height="auto" controls="controls" webkit-playsinline playsinline x5-video-player-type="h5-page">
        <source :src="formatAliyunPath(url)" :poster="formatAliyunPath(url)+'?x-oss-process=video/snapshot,t_5000,f_jpg'" type="video/mp4" />
        <source :src="formatAliyunPath(url)" :poster="formatAliyunPath(url)+'?x-oss-process=video/snapshot,t_5000,f_jpg'" type="video/ogg" />
        <source :src="formatAliyunPath(url)" :poster="formatAliyunPath(url)+'?x-oss-process=video/snapshot,t_5000,f_jpg'" type="video/webm" />
        <object :data="formatAliyunPath(url)" width="100%" height="auto">
          <embed :src="formatAliyunPath(url)" :poster="formatAliyunPath(url)+'?x-oss-process=video/snapshot,t_5000,f_jpg'" width="100%" height="auto" />
        </object>
      </video>
    </div>
    <iframe
      v-if="type === Dict.linkType.iframe"
      :src="formatAliyunPath(url)"
      id="iframe"
      frameborder="0"
      ref="iframe"
    ></iframe>
    <model-fbx v-if="type === Dict.linkType.fbx" :src="formatAliyunPath(url)"></model-fbx>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
import Dict from '@/core/dict'
import { ModelFbx } from 'vue-3d-model'
export default {
  components: { ModelFbx },
  data () {
    return {
      Dict: Dict,
      url: '',
      type: 'iframe',
    }
  },
  created () {
  },
  mounted () {
    this.url = decodeURIComponent(this.$route.query.url)
    console.log('iframe=>', this.url)
    this.type = this.$route.query.type
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path, 'k12')
    },
  }
}
</script>

<style lang="scss" scoped>
.content-webview {
  width: 100%;
}
#iframe {
  width: 100%;
  height: 100vh;
}
.medie-video {
  height: 100vh;
  background-color: rgba(0,0,0,1);
  .close-img {
    position: fixed;
    top: 10px;
    left: 10px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }
}
</style>
